import React, { useState, useEffect, useContext } from "react";
import { AppContext } from "../../context/AppContext";
import { Value } from "sass";
import { KEY_NAME } from "../../utils/KeyName";

const FUNDER_FIELD_GROUPS = [
  [
    {
      title: { label: "Author", value: "author" },
      fields: [
        { label: "Author name(s)", value: "author_name" },
        { label: "ORCID IDs", value: "orcid_id" },
      ],
    },
    {
      title: { label: "Institution", value: "institution" },
      fields: [
        // { label: "Affiliation name(s)", value: "affiliation_name" },
        { label: "Affiliation ROR(s)", value: "affiliation_ror" },
      ],
    },

    {
      title: { label: "Dataset / Software", value: "dataset_software" },
      fields: [
        // { label: "DOI", value: "doi" },
        // { label: "Dataset title", value: "dataset_title" },
        // { label: "First publication date", value: "first_publication_date" },
        // { label: "Latest publication date", value: "latest_publication_date" },
        // { label: "Dataset type", value: "dataset_type" },
        // { label: "Repository name", value: "repository_name" },
        { label: "Datasets", value: "datasets" },
      ],
    },
  ],
  [
    {
      title: { label: "Funder", value: "funder" },
      fields: [
        // { label: "DOI", value: "doi" },
        { label: "Funder ID", value: "funder_id" }, // it should be different value insted or doi
        { label: "Funder name(s)", value: "funder_name" },
        { label: "Funder ROR(s)", value: "funder_ror" },
        // { label: "Parent funder name(s)", value: "parent_funder_name" },
        // { label: "Parent funder ROR(s)", value: "parent_funder_ror" },
        // { label: "Funder country", value: "funder_country" },
        { label: "Grant ID(s)", value: "grant_id" },
        { label: "Funder portal URL(s)", value: "funder_portal_url" },
      ],
    },
  ],
  [
    {
      title: { label: "Article Metadata", value: "article_metadata" },
      fields: [
        { label: "DOI", value: "doi" },
        { label: "Article title", value: "article_title" },
        { label: "Online publication date", value: "online_publication_date" },
        { label: "Print publication date", value: "print_publication_date" },
        // { label: "Volume", value: "volume" },
        // { label: "Issue", value: "issue" },
        // { label: "Pages / article number", value: "pages_article_number" },
        { label: "Archive status", value: "archive_status" },
        // { label: "Publication type", value: "publication_type" },
        { label: "Publisher Name", value: "publisher" },
        { label: "Journal name", value: "journal_name" },
        // { label: "ISSN", value: "issn" },
        // { label: "Publisher", value: "publisher" },
      ],
    },
  ],

  [
    {
      title: { label: "License Metadata", value: "license_metadata" },
      fields: [
        {
          label: "Verified OA on publisher site",
          value: "verified_oa_publisher_site",
        },
        { label: "License type", value: "license_type" },
        { label: "License URL", value: "license_url" },
        {
          label: "Reuse License Start Date",
          value: "reuse_license_start_date",
        },
      ],
    },
  ],
];
// const NON_FUNDER_FIELD_GROUPS = [
//   [
//     {
//       title: { label: "Author", value: "author" },
//       fields: [
//         { label: "Author name(s)", value: "author_name" },
//         { label: "ORCID IDs", value: "orcid_id" },
//       ],
//     },
//     {
//       title: { label: "Institution", value: "institution" },
//       fields: [
//         // { label: "Affiliation name(s)", value: "affiliation_name" },
//         { label: "Affiliation ROR(s)", value: "affiliation_ror" },
//       ],
//     },
//   ],
//   [
//     {
//       title: { label: "Funder", value: "funder" },
//       fields: [
//         { label: "DOI", value: "doi" },
//         { label: "Funder name(s)", value: "funder_name" },
//         { label: "Funder ROR(s)", value: "funder_ror" },
//         // { label: "Parent funder name(s)", value: "parent_funder_name" },
//         // { label: "Parent funder ROR(s)", value: "parent_funder_ror" },
//         // { label: "Funder country", value: "funder_country" },
//         { label: "Grant ID(s)", value: "grant_id" },
//         { label: "Funder portal URL(s)", value: "funder_portal_url" },
//       ],
//     },
//   ],
//   [
//     {
//       title: { label: "Dataset / Software", value: "dataset_software" },
//       fields: [
//         // { label: "Dataset title", value: "dataset_title" },
//         // { label: "First publication date", value: "first_publication_date" },
//         // { label: "Latest publication date", value: "latest_publication_date" },
//         // { label: "Dataset type", value: "dataset_type" },
//         // { label: "Repository name", value: "repository_name" },
//         { label: "Datasets", value: "datasets" },
//       ],
//     },
//     {
//       title: { label: "Publisher Name", value: "publisherName" },
//       fields: [
//         { label: "Publisher Name", value: "publisher" },
//         { label: "Journal Name", value: "journal_name" },
//       ],
//     },
//   ],
//   [
//     {
//       title: { label: "Open Access", value: "open_access" },
//       fields: [
//         {
//           label: "Verified OA on publisher site",
//           value: "verified_oa_publisher_site",
//         },
//         { label: "License type", value: "license_type" },
//         { label: "License URL", value: "license_url" },
//         {
//           label: "Reuse License Start Date",
//           value: "reuse_license_start_date",
//         },
//       ],
//     },
//   ],
// ];

const PUBLISHER_FIELD_GROUPS = [
  [
    {
      title: { label: "Author", value: "author" },
      fields: [
        { label: "Author name(s)", value: "author_name" },
        { label: "ORCID IDs", value: "orcid_id" },
      ],
    },
    {
      title: { label: "Institution", value: "institution" },
      fields: [
        // { label: "Affiliation name(s)", value: "affiliation_name" },
        { label: "Affiliation ROR(s)", value: "affiliation_ror" },
      ],
    },
    {
      title: { label: "Dataset / Software", value: "dataset_software" },
      fields: [
        // { label: "Dataset title", value: "dataset_title" },
        // { label: "First publication date", value: "first_publication_date" },
        // { label: "Latest publication date", value: "latest_publication_date" },
        // { label: "Dataset type", value: "dataset_type" },
        // { label: "Repository name", value: "repository_name" },
        { label: "Datasets", value: "datasets" },
      ],
    },
  ],
  [
    {
      title: { label: "Funder", value: "funder" },
      fields: [
        // { label: "DOI", value: "doi" },
        { label: "Funder ID", value: "funder_id" }, // it should be different value insted or doi
        { label: "Funder name(s)", value: "funder_name" },
        { label: "Funder ROR(s)", value: "funder_ror" },
        // { label: "Parent funder name(s)", value: "parent_funder_name" },
        // { label: "Parent funder ROR(s)", value: "parent_funder_ror" },
        // { label: "Funder country", value: "funder_country" },
        { label: "Grant ID(s)", value: "grant_id" },
        { label: "Funder portal URL(s)", value: "funder_portal_url" },
      ],
    },
  ],
  [
    {
      title: { label: "Article Metadata", value: "article_metadata" },
      fields: [
        { label: "DOI", value: "doi" },
        // { label: "Funder ID", value: "funder_id" },
        { label: "Article title", value: "article_title" },
        { label: "Online publication date", value: "online_publication_date" },
        { label: "Print publication date", value: "print_publication_date" },
        { label: "Archive status", value: "archive_status" },
        // { label: "Publisher Name", value: "publisher" },
        { label: "Journal name", value: "journal_name" },
      ],
    },
  ],
  [
    {
      title: { label: "License Metadata", value: "license_metadata" },
      fields: [
        {
          label: "Verified OA on publisher site",
          value: "verified_oa_publisher_site",
        },
        { label: "License type", value: "license_type" },
        { label: "License URL", value: "license_url" },
        {
          label: "Reuse License Start Date",
          value: "reuse_license_start_date",
        },
      ],
    },
  ],
];

const INSTITUTION_FIELD_GROUPS = [
  [
    {
      title: { label: "Author", value: "author" },
      fields: [
        { label: "Author name(s)", value: "author_name" },
        { label: "ORCID IDs", value: "orcid_id" },
      ],
    },
    {
      title: { label: "Institution", value: "institution" },
      fields: [
        // { label: "Affiliation name(s)", value: "affiliation_name" },
        { label: "Affiliation ROR(s)", value: "affiliation_ror" },
      ],
    },
    {
      title: { label: "Dataset / Software", value: "dataset_software" },
      fields: [
        // { label: "Dataset title", value: "dataset_title" },
        // { label: "First publication date", value: "first_publication_date" },
        // { label: "Latest publication date", value: "latest_publication_date" },
        // { label: "Dataset type", value: "dataset_type" },
        // { label: "Repository name", value: "repository_name" },
        { label: "Datasets", value: "datasets" },
      ],
    },
  ],
  [
    {
      title: { label: "Funder", value: "funder" },
      fields: [
        { label: "Funder ID", value: "funder_id" }, // it should be different value insted or doi
        { label: "Funder name(s)", value: "funder_name" },
        { label: "Funder ROR(s)", value: "funder_ror" },
        // { label: "Parent funder name(s)", value: "parent_funder_name" },
        // { label: "Parent funder ROR(s)", value: "parent_funder_ror" },
        // { label: "Funder country", value: "funder_country" },
        { label: "Grant ID(s)", value: "grant_id" },
        { label: "Funder portal URL(s)", value: "funder_portal_url" },
      ],
    },
  ],
  [
    {
      title: { label: "Article Metadata", value: "article_metadata" },
      fields: [
        { label: "DOI", value: "doi" },
        // { label: "Funder ID", value: "doi" },
        { label: "Article title", value: "article_title" },
        { label: "Online publication date", value: "online_publication_date" },
        { label: "Print publication date", value: "print_publication_date" },
        { label: "Archive status", value: "archive_status" },
        { label: "Publisher Name", value: "publisher" },
        { label: "Journal name", value: "journal_name" },
      ],
    },
  ],
  [
    {
      title: { label: "License Metadata", value: "license_metadata" },
      fields: [
        {
          label: "Verified OA on publisher site",
          value: "verified_oa_publisher_site",
        },
        { label: "License type", value: "license_type" },
        { label: "License URL", value: "license_url" },
        {
          label: "Reuse License Start Date",
          value: "reuse_license_start_date",
        },
      ],
    },
  ],
];

const CustomReportFields = ({ handleActiveCustomField }) => {
  const [selectedHeader, setSelectedHeader] = useState({});
  const [selectedFields, setSelectedFields] = useState({});

  const { entityName } = useContext(AppContext);

  const handleChangeHeader = (header, fields) => {
    setSelectedHeader((prev) => ({
      ...prev,
      [header.value]: !prev[[header.value]],
    }));

    fields.map((field) =>
      setSelectedFields((prev) => ({
        ...prev,
        [field.value]: !selectedHeader[[header.value]],
      })),
    );
  };

  const handleChangeField = (header, field, fields) => {
    const allTrue = fields.fields.every((item) =>
      item.value === field.value
        ? !selectedFields[field.value]
        : selectedFields[item.value],
    );

    setSelectedFields((prev) => ({
      ...prev,
      [field.value]: !prev[[field.value]],
    }));

    if (allTrue) {
      //   handleChangeHeader(header.title, header.fields);
      setSelectedHeader((prev) => ({
        ...prev,
        [header.value]: true,
      }));
    } else {
      setSelectedHeader((prev) => ({
        ...prev,
        [header.value]: false,
      }));
    }
  };

  useEffect(() => {
    handleActiveCustomField(
      Object.keys(selectedFields).filter((key) => selectedFields[key]),
    );
  }, [selectedFields, selectedHeader]);

  return (
    <>
      <div className="d-sm-flex">
        {(entityName === KEY_NAME.FUNDER
          ? FUNDER_FIELD_GROUPS
          : entityName === KEY_NAME.PUBLISHER
            ? PUBLISHER_FIELD_GROUPS
            : INSTITUTION_FIELD_GROUPS
        ).map((group, index) => (
          <div key={index} className="me-5">
            {group.map((item, idx) => (
              <div key={idx} className="mb-3">
                {/* <p className="mb-1">{item.title}</p> */}
                <div key={item.title.value} className="d-flex gap-2 mb-1">
                  <input
                    type="checkbox"
                    id={item.title.value}
                    checked={selectedHeader[item.title.value] || ""}
                    className="form-check-input custom-checkbox"
                    onChange={() => handleChangeHeader(item.title, item.fields)}
                  />
                  <label
                    htmlFor={item.title.value}
                    className="fw-semibold text-dark"
                  >
                    {item.title.label}
                  </label>
                </div>

                {item.fields.map((field) => (
                  <div key={field.value} className="d-flex gap-2 ps-3 mb-1">
                    <input
                      type="checkbox"
                      id={field.value}
                      checked={
                        selectedHeader[item.title.value] ||
                        selectedFields[field.value] ||
                        ""
                      }
                      className="form-check-input custom-checkbox"
                      onChange={() =>
                        handleChangeField(item.title, field, item)
                      }
                    />
                    <label htmlFor={field.value} className="">
                      {field.label}
                    </label>
                  </div>
                ))}
              </div>
            ))}
          </div>
        ))}
      </div>
      <hr />
    </>
  );
};

export default CustomReportFields;
